import { makeAutoObservable, runInAction } from "mobx";
import { onB2BError } from "@/utils/b2bErrors";
/**
 * Взаиморасчёты активной компании кабинета (UC1130 skeleton → UC1134) — `corp_my_invoices`,
 * `corp_my_invoice_lines`, `corp_my_payments`, `corp_my_ledger`. Только чтение — ни одного финансового RPC.
 */
export class CorpSettlementsStore {
    constructor(settlementsService) {
        this.settlementsService = settlementsService;
        this.invoices = [];
        this.payments = [];
        this.ledger = [];
        this.lines = {};
        this.isLoading = false;
        this.companyId = null;
        this.generation = 0;
        makeAutoObservable(this, {
            settlementsService: false,
            companyId: false,
            generation: false,
        });
    }
    async init(companyId) {
        this.dispose();
        this.companyId = companyId;
        await this.load();
    }
    async load() {
        const companyId = this.companyId;
        if (!companyId)
            return;
        const generation = this.generation;
        this.isLoading = true;
        // Строки счетов перечитываются после каждой загрузки — их состав мог измениться.
        this.lines = {};
        try {
            const [invoices, payments, ledger] = await Promise.all([
                this.settlementsService.listInvoices(companyId),
                this.settlementsService.listPayments(companyId),
                this.settlementsService.listLedger(companyId),
            ]);
            runInAction(() => {
                if (generation !== this.generation)
                    return;
                this.invoices = invoices;
                this.payments = payments;
                this.ledger = ledger;
            });
        }
        catch (error) {
            onB2BError(error, "Не удалось загрузить взаиморасчёты компании", "corpCabinet");
        }
        finally {
            runInAction(() => {
                if (generation === this.generation)
                    this.isLoading = false;
            });
        }
    }
    async openInvoice(invoiceId) {
        const companyId = this.companyId;
        if (!companyId || this.lines[invoiceId])
            return;
        try {
            const lines = await this.settlementsService.listInvoiceLines(companyId, invoiceId);
            runInAction(() => {
                this.lines[invoiceId] = lines;
            });
        }
        catch (error) {
            onB2BError(error, "Не удалось загрузить строки счёта", "corpCabinet");
        }
    }
    dispose() {
        this.generation += 1;
        this.companyId = null;
        this.invoices = [];
        this.payments = [];
        this.ledger = [];
        this.lines = {};
        this.isLoading = false;
    }
}
